import { AfterViewInit, Component, EventEmitter, NgZone, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DatosComercioServiceVM } from 'src/app/view-model/services/datos-comercio.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { TokenSaverService } from 'src/app/view-model/services/token-saver.service';
import { JWTValidator } from 'src/app/view-model/utils/jwt-validator';
import { environment } from '../../../../environments/environment';

const env = environment;
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnDestroy, AfterViewInit {

  @Output() accionBtn: EventEmitter<any> = new EventEmitter();

  products$ = this.carroService.products$;

  private tokenExterno: string;
  private run: number;
  private origen: string;
  private codigoRespuesta: string;

  show = false;
  private subscription: Subscription;
  constructor(
    private carroService: CarroComprasService,
    private tokenSaver: TokenSaverService,
    private stepperServiceVM: StepperServiceVM,
    private productService: vmProductosService,
    private storage: LocalStorageService,
    private flujos: FlujosPaso2Service,
    private ngZone: NgZone,
    private router: Router,
    private datosComercioServiceVM: DatosComercioServiceVM,
    private tagM:TagManagerService
  ) { }

  ngAfterViewInit() {
    const parameters = this.carroService.loadFromUrl();
    if (parameters) {
      if (parameters.token) {
        this.validateToken(parameters.token);
      } else {
        this.storage.resertApp();
        this.evaluarPaso();
      }
    } else {
      const urlParams = this.router.parseUrl(this.router.url);
      const action = urlParams.queryParams.action;
      this.tokenExterno = localStorage.getItem('token');
      this.run = +localStorage.getItem('run');
      this.origen = localStorage.getItem('origen');
      this.codigoRespuesta = (localStorage.getItem('C')) ? localStorage.getItem('C') : 'PP';
      const spinner: boolean = (localStorage.getItem('spinner')) ? true : false;
      if (this.origen) {
        this.storage.setCurrentPage(_.get(env, 'localStorage.LOADING', ''));
        this.datosComercioServiceVM.autenticacaComercio(this.run, this.tokenExterno).toPromise();
      } else if (!spinner || action === 'retoma') {
        this.storage.resertApp();
      }
      this.evaluarPaso();
    }
    this.subscription = this.carroService.mostrarCarro$.subscribe((show) => {
      this.show = show;
    });
  }

  async evaluarPaso() {
    const currentPage = this.storage.getCurrentPage();
    const paso_2 = _.get(env, 'localStorage.PASO_2', '');
    const paso_3 = _.get(env, 'localStorage.PASO_3', '');
    const loading = _.get(env, 'localStorage.LOADING', '');
    if (!currentPage) {

      this.flujos.paso1Created = true;
      this.carroService.changePaso('P_1');
      if(this.carroService.getCurrentProduct()){
        this.tagM.logEvent (GoogleTagManager.eventViewCart().setEtiqueta(this.carroService.getCurrentProduct().title));
      }
    } else if (currentPage === paso_2) {
      this.carroService.changePaso('P_2');
      this.stepperServiceVM.nextStep();
      await this.productService.cargaSeleccionActualEnCarro().toPromise();
    } else if (currentPage === paso_3) {
      this.carroService.changePaso('P_3');
      this.stepperServiceVM.nextStep();
      this.stepperServiceVM.nextStep();
      await this.productService.cargaSeleccionActualEnCarro().toPromise();
    } else if (currentPage === loading) {
      this.router.navigate(['/spinner/' + this.origen + '/' + this.codigoRespuesta]);
    }
  }

  async validateToken(token: string): Promise<void> {
    
    const jwtValidator = new JWTValidator();
    if (!jwtValidator.isExpired(token)) {
      this.tokenSaver.saveToken('Bearer ' + token);
      try {

        await this.productService.registraSeleccionProductoActual().toPromise();
        const products = await this.productService.cargaSeleccionActualEnCarro().toPromise();
        
        if (products && products.length > 0) {
          this.stepperServiceVM.nextStep();
        }
      } catch (exception) {
        // cant register products because dont have products or expired session
        console.error('product register error: ', exception);
      }
    } else {
      this.storage.resertApp();
      this.evaluarPaso();
    }
  }

  get show$(): Observable<boolean> {
    return this.carroService.mostrarCarro$;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
